import View from './SubHeader';
import enhancer from './SubHeader.enhancer';

const SubHeader = enhancer(View);

export default SubHeader;
